import React, { Component } from "react";
import { Redirect } from "react-router";
import { login, backendLogin, fetchJwks } from "../../actions";
import { connect } from "react-redux";
import { compose } from "redux";
import { instanceOf } from "prop-types";
import { withCookies, Cookies } from "react-cookie";

import "../../static/style/login.css";
import { FormattedMessage } from "react-intl";
require("dotenv").config({ path: "../../../.env" });

class Tupas extends Component {
  static propTypes = {
    cookies: instanceOf(Cookies).isRequired
  };

  constructor(props, context) {
    super(props, context);

    this.signin = this.signin.bind(this);
    this.setPin = this.setPin.bind(this);
    this.setPin2 = this.setPin2.bind(this);
    this.getUrl = this.getUrl.bind(this);
  }

  componentWillMount() {
    const { cookies } = this.props;
    const signicat_state =
      Math.random()
        .toString(36)
        .substring(2, 15) +
      Math.random()
        .toString(36)
        .substring(2, 15);

    this.setState({
      pin: "",
      loggedIn: false,
      signicat_state: signicat_state,
      url: '',
      loading: true
    });

    cookies.set("state", signicat_state, {
      path: "/"
    });
  }

  componentDidMount() {
    this.props.fetchJwks()
  }

  componentWillUpdate(nextProps) {
    if (window.sessionStorage.accessToken) {
      // console.log("REDIRECTING");
      this.setState({
        loggedIn: true
      });
    }
  }

  signin() {
    // this.props.login(this.state.pin)
    this.props.backendLogin(this.state.pin);
    // console.log(window.sessionStorage.accessToken);
  }

  setPin(pin) {
    this.setState({
      pin: pin.target.value
    });
  }

  setPin2(pin) {
    this.setState({
      pin: pin
    });
  }

  getUrl() {
    const url = `${process.env.REACT_APP_SIGNICAT_URL}connect/authorize`
    this.setState({
      url: url,
      loading: false
    })
  }

  render() {
    if (this.state.loggedIn) {
      return <Redirect to="/dashboard" />;
    }

    if (!this.props.jwks) {
      return (
        <div className="row">
          <div className="col-sm-12">
            <h1 className="header1">
              <FormattedMessage id="app.loading" defaultMessage="Ladataan..." />
            </h1>
          </div>
        </div>
      );
    }

    if (this.props.error) {
      if (this.props.error === 500) {
        return <Redirect to={"/500"} />;
      } else {
        return <Redirect to={"/404"} />;
      }
    }

    return (
      <div>
        <div className="row">
          <div className="col-md-12">
            <h1>
              <FormattedMessage id="tupas.letter.title" defaultMessage="Saitko meiltä kirjeen?"/>
            </h1>
            <h2>
              <FormattedMessage id="tupas.letter.subtitle"
                                defaultMessage="Kaikki järjestyy kyllä. Hoidetaan yhdessä raha-asiasi kuntoon."/>
            </h2>
            <p>
              <FormattedMessage id="tupas.letter.p1"
                                defaultMessage="Joskus eteen tulee tilanteita, joissa laskuista suoriutuminen eräpäivään mennessä aiheuttaa haasteita. Joustavana laskutus- ja perintätoimistona olemme tukenasi."/>
            </p>
            <p>
              <FormattedMessage id="tupas.letter.p2"
                                defaultMessage="Brangin Luotsi-palvelussa voit maksaa laskusi, tehdä osamaksusopimuksen tai siirtää laskun eräpäivää."/>
            </p>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <h1>
              <FormattedMessage id="tupas.law.title" defaultMessage="Luottotietolakiin muutoksia"/>
            </h1>
            <h2>
              <FormattedMessage id="tupas.law.subtitle"
                                defaultMessage="Maksuhäiriömerkinnät alkavat poistua 30 päivän kuluessa velan maksusta."/>
            </h2>
            <p>
              <FormattedMessage id="tupas.law.p1"
                                defaultMessage="1.12.2022 alkaen maksuhäiriömerkinnät poistuvat luottotietorekisteristä 30 päivän kuluessa siitä, kun tieto velan maksamisesta on rekisteröity luottotietorekisteriin."/>
            </p>
            <p>
              <FormattedMessage id="tupas.law.p2"
                                defaultMessage="Nyt siis kannattaa maksaa avoimet velat, vaikka niistä olisi jo syntynyt maksuhäiriömerkintä."/>
            </p>
          </div>
        </div>
        <div className="row tunnistaudu">
          <div className="col-md-12">
            <h1>
              <FormattedMessage id="tupas.login.title" defaultMessage="Tunnistaudu palveluun"/>
            </h1>
            <p>
              <FormattedMessage id="tupas.login.desc" defaultMessage="Voit kirjautua Luotsiin pankkitunnuksilla."/>
            </p>
            <a
              href={`${process.env.REACT_APP_SIGNICAT_URL}connect/authorize?request=${this.props.jwks.jwks}&client_id=${process.env.REACT_APP_CLIENT_ID}`}
              className={"btn btn-primary"}
            >
              <FormattedMessage
                id="app.nav.login"
                defaultMessage="TUNNISTAUDU"
              />
            </a>
            <br />
            {process.env.REACT_APP_ENV === "development" ? (
              <div>
                <br />
                <input
                  onChange={this.setPin}
                  value={this.state.pin}
                  type={"text"}
                  placeholder={"210281-9988"}
                />
                <button
                  onClick={() => this.signin()}
                  className={"btn btn-primary"}
                >
                  <FormattedMessage id="tupas.dev.login" defaultMessage="DEV LOGIN" />
                </button>
              </div>
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = function(store) {
  return {
    login: store.login,
    error: store.error.error,
    jwks: store.jwks
  };
};

const mapDispatchToProps = dispatch => ({
  login: id => dispatch(login(id)),
  backendLogin: pin => dispatch(backendLogin(pin)),
  fetchJwks: () => dispatch(fetchJwks())
});

export default compose(
  withCookies,
  connect(mapStateToProps, mapDispatchToProps)
)(Tupas);



// WEBPACK FOOTER //
// ./src/containers/static/tupas.js